import React from 'react'
import { Card, Carousel, CarouselItem, Col, Row } from 'react-bootstrap'

import VideoPlayer from '../../common/VideoPlayer';

const Winery = () => {

    return (
        <>
            <Card className='text-center no-border rounded-0 industrial-modeling-top-section container'>
                <Card.Body>
                    <Card.Title className='industrial-modeling-title'> ワイン醸造所のIoT化 </Card.Title>
                    <Card.Text className='industrial-modeling-text text-left'>
                    すでにデータを収集している技術や設備は、デジタルツインに最適なモデルです。IoTデバイスは、IoTデバイスは、センサーデータをリアルタイムで表示する3Dデジタルツインと連携して活用することができます。収集したデータを3Dデジタルツイン上で表示し、各項目の状態を常に把握することができます。
                    <br />
                    <br /> 
                    例えば，ワイン醸造所などの施設の3Dデジタルツインを構築し，リアルタイムIoTセンサーデータを使って個々の樽のワイン量，温度，その他のステータスを表示するプロジェクトをサポートしました。
                    </Card.Text>
                    <Row >
                        <Col md={{span:8, offset:2}} className='container'>
                            <VideoPlayer videosource="/assets/digital-twin/winery/video/Winery.mp4" class="winery-video container" />
                        </Col>
                    </Row>
                </Card.Body>
            </Card>
            <Card className='no-border rounded-0 winery-carousel-section py-4 py-md-5 my-5 my-md-0 container'>
            <Row>
                <Col>
                <Carousel className='winery-carousel' interval={null}>
                <CarouselItem>
                        <Row>
                            <Col xs={{span:1, offset:0}} className="d-none d-md-block">
                                <Card className='no-border rounded-0 left-partial-display-section'>
                                    <Card.Img className='partial-display-image' src={"/assets/digital-twin/winery/images/w_003_01.jpg"} />
                                    <Card.Body>
                                    <Card.Title className='architectural-modeling-footer-title'></Card.Title>
                                    </Card.Body>
                                </Card>
                            </Col>
                            <Col xs={{span:12, offset:0}} md={{span:5, offset:0}} className="industrial-invironments-slider-card">
                                <Card className='no-border rounded-0 architectural-modeling-card '>
                                    <Card.Img className='main-slider-image' src={"/assets/digital-twin/winery/images/w_001.jpg"} />
                                    <Card.Body>
                                    <Card.Title className='architectural-modeling-footer-title'> 現実世界のワイン醸造所 <br /> （参考写真） </Card.Title>
                                    </Card.Body>
                                </Card>
                            </Col>
                            <Col xs={{span:12, offset:0}} md={{span:5, offset:0}} className="industrial-invironments-slider-card">
                                <Card className='no-border rounded-0 architectural-modeling-card '>
                                    <Card.Img className='main-slider-image' src={"/assets/digital-twin/winery/images/w_001_01.jpg"} />
                                    <Card.Body>
                                    <Card.Title className='architectural-modeling-footer-title'> 仮想空間（VR）のワイン醸造所 <br /> （3Dモデルのレンダリング画像） </Card.Title>
                                    </Card.Body>
                                </Card>
                            </Col>

                            <Col xs={{span:1, offset:0}} className="d-none d-md-block">
                                <Card className='no-border rounded-0 right-partial-display-section'>
                                    <Card.Img className='partial-display-image' src={"/assets/digital-twin/winery/images/w_002.jpg"} />
                                    <Card.Body>
                                    <Card.Title className='architectural-modeling-footer-title'></Card.Title>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>
                    </CarouselItem>
                    <CarouselItem>
                        <Row>
                            <Col xs={{span:1, offset:0}} className="d-none d-md-block">
                                <Card className='no-border rounded-0 left-partial-display-section'>
                                    <Card.Img className='partial-display-image' src={"/assets/digital-twin/winery/images/w_001_01.jpg"} />
                                    <Card.Body>
                                    <Card.Title className='architectural-modeling-footer-title'></Card.Title>
                                    </Card.Body>
                                </Card>
                            </Col>
                            <Col xs={{span:12, offset:0}} md={{span:5, offset:0}} className="industrial-invironments-slider-card">
                                <Card className='no-border rounded-0 architectural-modeling-card'>
                                    <Card.Img className='main-slider-image' src={"/assets/digital-twin/winery/images/w_002.jpg"} />
                                    <Card.Body>
                                    <Card.Title className='architectural-modeling-footer-title'> 現実世界のワイン醸造所 <br /> （参考写真） </Card.Title>
                                    </Card.Body>
                                </Card>
                            </Col>
                            <Col xs={{span:12, offset:0}} md={{span:5, offset:0}} className="industrial-invironments-slider-card">
                                <Card className='no-border rounded-0 architectural-modeling-card '>
                                    <Card.Img className='main-slider-image' src={"/assets/digital-twin/winery/images/w_002_01.jpg"} />
                                    <Card.Body>
                                    <Card.Title className='architectural-modeling-footer-title'> 仮想空間（VR）のワイン醸造所 <br /> （3Dモデルのレンダリング画像） </Card.Title>
                                    </Card.Body>
                                </Card>
                            </Col>

                            <Col xs={{span:1, offset:0}} className="d-none d-md-block">
                                <Card className='no-border rounded-0 right-partial-display-section'>
                                    <Card.Img className='partial-display-image' src={"/assets/digital-twin/winery/images/w_003.jpg"} />
                                    <Card.Body>
                                    <Card.Title className='architectural-modeling-footer-title'></Card.Title>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>
                    </CarouselItem>
                    <CarouselItem>
                        <Row>
                            <Col xs={{span:1, offset:0}} className="d-none d-md-block">
                                <Card className='no-border rounded-0 left-partial-display-section'>
                                    <Card.Img className='partial-display-image' src={"/assets/digital-twin/winery/images/w_002_01.jpg"} />
                                    <Card.Body>
                                    <Card.Title className='architectural-modeling-footer-title'></Card.Title>
                                    </Card.Body>
                                </Card>
                            </Col>

                            <Col xs={{span:12, offset:0}} md={{span:5, offset:0}} className="industrial-invironments-slider-card">
                                <Card className='no-border rounded-0 architectural-modeling-card '>
                                    <Card.Img className='main-slider-image' src={"/assets/digital-twin/winery/images/w_003.jpg"} />
                                    <Card.Body>
                                    <Card.Title className='architectural-modeling-footer-title'> 現実世界のワイン醸造所 <br /> （参考写真） </Card.Title>
                                    </Card.Body>
                                </Card>
                            </Col>
                            <Col xs={{span:12, offset:0}} md={{span:5, offset:0}} className="industrial-invironments-slider-card">
                                <Card className='no-border rounded-0 architectural-modeling-card'>
                                    <Card.Img className='main-slider-image' src={"/assets/digital-twin/winery/images/w_003_01.jpg"} />
                                    <Card.Body>
                                    <Card.Title className='architectural-modeling-footer-title'> 仮想空間（VR）のワイン醸造所 <br /> （3Dモデルのレンダリング画像） </Card.Title>
                                    </Card.Body>
                                </Card>
                            </Col>

                            <Col xs={{span:1, offset:0}} className="d-none d-md-block">
                                <Card className='no-border rounded-0 right-partial-display-section'>
                                    <Card.Img className='partial-display-image' src={"/assets/digital-twin/winery/images/w_001.jpg"} />
                                    <Card.Body>
                                    <Card.Title className='architectural-modeling-footer-title'></Card.Title>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>
                    </CarouselItem>
                </Carousel>
                </Col>
            </Row>
            </Card>
        </>
    )
}

export default Winery
